var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hero)?_c('div',{class:_vm.$style.container,attrs:{"id":"hud-innate"}},[_c('innate-tooltip',{attrs:{"hero":_vm.hero.name,"position":"top"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }